import { css } from 'aphrodite';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IUserSessionComponentProps, UserSessionViewModelKey } from '../../../models/AppState';
import { IEventLoggingComponentProps, withEventLogging } from '../../../models/Logging';
import { PrivateVisibilityIcon } from '../svgs/icons/PrivateVisibilityIcon';
import { PublicVisibilityIcon } from '../svgs/icons/PublicVisibilityIcon';
import { styleSheet } from './styles';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@HoudiniUI/Select';

export type ResourceVisibility = 'all' | 'admin' | string;

const VisibilityOptions: {
	label: string;
	value: ResourceVisibility;
}[] = [
	{
		label: 'All employees',
		value: 'all',
	},
	{
		label: 'Private',
		value: 'admin',
	},
];

interface IProps extends IUserSessionComponentProps, IEventLoggingComponentProps {
	className?: string;
	disabled?: boolean;
	onVisibilityChanged?(visibility: ResourceVisibility): void;
	visibility: ResourceVisibility;
}

interface IState {
	selectedOption?: ResourceVisibility;
}

class _VisibilityDropdown extends React.Component<IProps, IState> {
	public readonly state: IState = {};

	public UNSAFE_componentWillMount() {
		const visibility = this.props.visibility === 'all' ? 'all' : 'admin';
		this.setState({
			selectedOption: visibility,
		});
	}

	public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
		if (!!this.state.selectedOption && nextProps.visibility !== this.state.selectedOption) {
			this.setState({
				selectedOption: nextProps.visibility || 'admin',
			});
		}
	}

	public render() {
		const { className, disabled } = this.props;
		const { selectedOption } = this.state;
		return (
			<div className={`${className || ''}`}>
				<Select
					items={VisibilityOptions}
					value={selectedOption}
					onValueChange={this.onSelectionChanged}
					disabled={disabled}
				>
					<SelectTrigger styles={[styleSheet.trigger]}>
						<div className={css(styleSheet.selectValueDisplay)}>
							{selectedOption === 'all' ? <PublicVisibilityIcon /> : <PrivateVisibilityIcon />}
							Visibility: <SelectValue />
						</div>
					</SelectTrigger>
					<SelectContent>
						{VisibilityOptions.map(({ label, value }) => (
							<SelectItem key={value} value={value}>
								<span className={css(styleSheet.selectItem)}>
									{value === 'all' ? <PublicVisibilityIcon /> : <PrivateVisibilityIcon />} {label}
								</span>
							</SelectItem>
						))}
					</SelectContent>
				</Select>
			</div>
		);
	}

	private onSelectionChanged = (selectedOption: ResourceVisibility) => {
		const { onVisibilityChanged } = this.props;
		if (onVisibilityChanged) {
			onVisibilityChanged(selectedOption);
		} else {
			this.setState({
				selectedOption,
			});
		}
	};
}

const VisibilityDropdownAsObserver = observer(_VisibilityDropdown);
const VisibilityDropdownWithContext = inject(UserSessionViewModelKey)(VisibilityDropdownAsObserver);
export const VisibilityDropdown = withEventLogging(VisibilityDropdownWithContext, 'VisibilityDropdown');
